import { Component } from "react"

/* Modal */
import Modal from "react-modal"

/* Components */
import { Icon } from "../../components"

/* Icons */
import { LoadingOutlined } from "@ant-design/icons"

/* REST API */
import { status } from "../../api/Queue"

/* Widgets */
import { toast } from "../common"

Modal.setAppElement("#root")


/* The reasons a ticket is closed by hand — the rest is written into the line below them */
const REASONS = ["Клиент ушёл", "Клиент передумал", "Заведение закрылось", "Дубль талона", "Ошибка администратора"]


/* Widget Cancel Modal — the ticket is cancelled with a reason, so the history of the point
   says later why it was closed. It is opened by the reference: this._cancel.current.open(item) */
class CancelModal extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
            saving: false,

            id: 0,
            reason: "",
            notify: true
        }
    }

    /* Open the form */
    open = item => {
        this.setState({ visible: true, saving: false, id: item.id, reason: "", notify: true })
    }

    /* Close the form */
    close = () => {

        /* The request is already on its way */
        if (this.state.saving) {
            return
        }

        this.setState({ visible: false })
    }

    /* Cancel the ticket */
    save = () => {

        /* Fields */
        const { saving, id, reason, notify } = this.state
        const { onSaved } = this.props

        /* The request is already on its way */
        if (saving) {
            return
        }

        this.setState({ saving: true })

        status({ id, status: "CANCELLED", comment: reason.trim().length > 0 ? reason.trim() : null, notify }).then(response => {

            if (response && response.status === 200) {

                this.setState({ visible: false, saving: false })

                toast.success("Талон отменён")

                if (onSaved) {
                    onSaved()
                }
            }
            else {
                this.setState({ saving: false })
                toast.error("Не удалось отменить талон")
            }
        }).catch(() => {
            this.setState({ saving: false })
            toast.error("Не удалось отменить талон")
        })
    }

    render = () => {

        /* Fields */
        const { visible, saving, reason, notify } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={this.close}
                className="queue-form-modal"
                overlayClassName="queue-form-overlay"
                closeTimeoutMS={200}
            >

                <div className="queue-form-header">
                    <h2>Отменить талон</h2>
                    <div onClick={this.close} className="queue-form-close">
                        <Icon name="close" size={11} width={2.2} />
                    </div>
                </div>

                <div className="queue-form-body">

                    <div className="queue-form-hint">Причина остаётся в истории талона — по ней потом видно, почему клиент не дошёл до кресла.</div>

                    <div className="queue-form-label">Причина отмены</div>

                    <div className="queue-form-chips">
                        {REASONS.map(item =>
                            <div
                                key={item}
                                onClick={() => this.setState({ reason: item })}
                                className={`queue-form-chip ${reason === item ? "active" : ""}`}
                            >
                                {item}
                            </div>
                        )}
                    </div>

                    <input
                        className="queue-form-input"
                        placeholder="Своя причина"
                        value={reason}
                        maxLength={200}
                        onChange={event => this.setState({ reason: event.target.value })}
                    />

                    <div onClick={() => this.setState({ notify: !notify })} className={`queue-form-check ${notify ? "active" : ""}`}>
                        <i />
                        <span>Сообщить клиенту об отмене</span>
                    </div>

                </div>

                <div className="queue-form-footer">
                    <div onClick={this.close} className="queue-form-button light">Назад</div>
                    <div onClick={this.save} className={`queue-form-button danger ${saving ? "disabled" : ""}`}>
                        {saving ? <LoadingOutlined /> : "Отменить талон"}
                    </div>
                </div>

            </Modal>
        )
    }
}

export default CancelModal
